import { BOOKING_TYPES } from 'models/BookingType';

export const VRBO_AVAILABLE_BOOKING_TYPES = [
  BOOKING_TYPES.BOOKING_REQUEST,
  BOOKING_TYPES.INSTANT_BOOKING,
];
